import { CORPORATE_NAME } from "../../api/Constants";
import ReactDOM from "react-dom";
import videoTips from "../../images/VideoTips.jpeg";
const Origins = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "The Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo, Democratic Republic of the",
  "Congo, Republic of the",
  "Costa Rica",
  "Côte d’Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor (Timor-Leste)",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "The Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, North",
  "Korea, South",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia, Federated States of",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar (Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Sudan, South",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];
export default Origins;

export const Faqs = [
  {
    type: "video",
    question: "How to add your team member in your team?",
    video_link: "https://youtu.be/H1QKYmMOSAM",
    answer: "",
  },
  {
    type: "video",
    question: "How to register more than one team as a coach?",
    video_link: "https://youtu.be/VDZQUJTJqTQ",
    answer: `<strong>Step 1:</strong> Change a team leader of the team you have joined as a team leader - you don't have to be part of any team as a team leader in order to register more teams.
    <br><br><strong>Step 2:</strong> Leave team.
    <br><br><strong>Step 3:</strong> Register for more teams and repeat the same if you want to register more than 1 teams as a coach.
  `,
  },
  {
    type: "text",
    question: `What type of fitness challenge can we host on ${CORPORATE_NAME}?`,
    answer: `
      You can host both physical (onsite) and virtual challenges on ${CORPORATE_NAME}.
    `,
  },
  {
    type: "text",
    question:
      "How can I publish private challenges and what does it require?",
    answer: `
      Private fitness challenges can be created in a similar way as public fitness challenges. There are a few points to consider:
      <ul>
        <li>Select the private option when creating a challenge.</li>
        <li>Add a code value while creating the challenge; this code will be shared with athletes who are joining the challenge.</li>
        <li>If it is a free challenge, no additional steps are needed.</li>
        <li>If it is a paid challenge, you need to get approval from Stripe. This can be done from the dashboard under the payment option.</li>
        <li>Once the challenge is created, the organizer will receive an email and link of a challenge to be shared with athletes joining upon click.</li>
      </ul>
    `,
  },
  {
    type: "text",
    question: "How can I add sponsors to my challenges?",
    answer: `
      You can add sponsors based on workouts. While creating workouts, you can add the sponsor's logo and name. Each workout can have one sponsor type and name.
    `,
  },
  {
    type: "text",
    question: "What is the fitness challenge flow from an organizer's point of view?",
    answer: `
      Here is the fitness challenge flow for an organizer:
      <ul>
        <li>Create a fitness challenge (public/private) or (free/paid).</li>
        <li>Create categories (Divisions) for the fitness challenge.</li>
        <li>Add workouts as per category (division).</li>
        <li>Create schedule/heats.</li>
        <li>Manage the leaderboard – here teams and workouts will auto populate, all you need is to add score.</li>
      </ul>
    `,
  },
  {
    type: "text",
    question:
      "How can I contact athletes/teams from a fitness challenge organizer's point of view?",
    answer: `
      You can contact teams/athletes from the "Messages" section. You can email teams based on the fitness challenge and select specific team names. Additionally, you can send a broadcast message to all teams at once.
    `,
  },
  {
    type: "text",
    question: "Are there any charges to run private/public fitness challenges?",
    answer: `
      There are no fees for running fitness challenges from the organizers' point of view for the year 2024 (early adopters). However, this policy is subject to change in future.
    `,
  },
  {
    type: "text",
    question: "What is the fitness challenge payout duration?",
    answer: `
      By default, total balance payouts will be made on the 1st of every month. For customization, please contact us at info@metabuddy.app.
    `,
  },
  {
    type: "text",
    question: "How to submit virtual fitness challenge score?",
    answer: `<iframe width="379" height="674" 
    src="https://www.youtube.com/embed/GBVUaZK5QTA" 
    title="How to submit virtual fitness challenge score?" 
    frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
    </iframe>`,
  },
  {
    type: "text",
    question: "Tips to record better video for virtual fitness challenge Scoring",
    answer: `<a href=${videoTips} target="_blank" rel="noopener noreferrer">
               <img src=${videoTips} alt="" style="width: 100%; padding-top: 10px; padding-bottom: 10px;" />
             </a>`,
  },
  {
    type: "text",
    question: `What benefits does an athlete get from registering with ${CORPORATE_NAME} and participating in fitness challenges?`,
    answer: `
      Athletes registered with ${CORPORATE_NAME} enjoy several advantages:
      <ul>
        <li><b>Competition Rank Score Management:</b> ${CORPORATE_NAME} maintains a comprehensive record of an athlete's fitness challenge rank scores, which can be utilized for future achievements such as badges on athletes' bags.</li>
        <li><b>Participation Recognition:</b> Each competition participation allows athletes to request participation stickers or badges, enhancing their personal achievements and recognition.</li>
        <li><b>WOD Record Comparison:</b> Athletes can compare their Workout of the Day (WOD) records within the ${CORPORATE_NAME} app, helping them gauge their performance and make informed decisions for future fitness challenges.</li>
        <li><b>AI and Machine Learning Benefits:</b> ${CORPORATE_NAME}'s data-driven approach enables AI and machine learning algorithms to suggest optimal partners for fitness challenges based on athletes' performance data, enhancing collaboration and competitive edge.</li>
      </ul>
      These features collectively empower athletes with tools to track progress, gain recognition, and optimize their competitive strategies through advanced technology.
    `,
  },
  {
    type: "video",
    question: "Personalized Programs & Nutrition Goals Powered by AI",
    video_link: "https://firebasestorage.googleapis.com/v0/b/metabuddy-corporate.firebasestorage.app/o/global_videos%2FAI%20Proposed%20Programs.mp4?alt=media&token=8cabbc32-0409-47d7-bbbb-885667567efe",
    answer: "",
  },
  {
    type: "video",
    question: "How MetaBuddy AI Copilot Assistant works?",
    video_link: "https://firebasestorage.googleapis.com/v0/b/metabuddy-corporate.firebasestorage.app/o/global_videos%2FAI-Intro.mp4?alt=media&token=ce1a5e36-4df5-43e6-9891-a64ce3a1cbe2",
    answer: "",
  },
  {
    type: "video",
    question: "How to get Onboard with MetaBuddy Using the guided wizard",
    video_link: "https://firebasestorage.googleapis.com/v0/b/metabuddy-corporate.firebasestorage.app/o/global_videos%2FHow%20to%20get%20into%20the%20app.mp4?alt=media&token=1ec33ed2-e526-4456-85a4-54941aab6f74",
    answer: "",
  },
  {
    type: "video",
    question: "How to track your daily nutrition?",
    video_link: "https://firebasestorage.googleapis.com/v0/b/metabuddy-corporate.firebasestorage.app/o/global_videos%2FNutritions%20Intro.mp4?alt=media&token=efb32f8c-d1de-40bc-9119-bd4d3239ef52",
    answer: "",
  },
];

export let CURRENT_PAGE = `/`;

export const setCurrentPage = (newPage) => {
  CURRENT_PAGE = newPage;
};

export const isTrainerAccount = () => {
  const accountType = localStorage.getItem("accountType");
  if (accountType === "corporate_admin" || accountType === "admin" || accountType === "trainer") return true;
  else return false;
};

export const isAdminAccount = () => {
  const accountType = localStorage.getItem("accountType");
  if (accountType === "corporate_admin" || accountType === "admin") return true;
  else return false;
};

export const isCorporateAdminAcc = () => {
  const accountType = localStorage.getItem("accountType");
  if (accountType === "corporate_admin") return true;
  else return false;
};

export const isTrainee = () => {
  const accountType = localStorage.getItem("accountType");
  if (accountType === "trainee") return true;
  else return false;
};

export const isReceptionist = () => {
  const accountType = localStorage.getItem("accountType");
  if (accountType === "receptionist") return true;
  else return false;
};

export const ADD_ELEMENT_ON_TOP = (newElement, id, newDivId) => {
  const container = document.getElementById(id);
  if (!container) {
    console.error(`Container with id ${id} not found!`);
    return;
  }

  const existingDiv = document.getElementById(newDivId);
  if (existingDiv) {
    console.log(
      `Element with id ${newDivId} already exists. Skipping addition.`
    );
    return;
  }

  const newDiv = document.createElement("div");
  newDiv.id = newDivId;
  container.prepend(newDiv);
  ReactDOM.render(newElement, newDiv);
};

export const REMOVE_ELEMENT = (elementId) => {
  const elementToRemove = document.getElementById(elementId);
  if (!elementToRemove) {
    console.error(`Element with id ${elementId} not found!`);
    return;
  }

  elementToRemove.remove();
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const getImageUrl = (imageName, baseUrl) =>{
  if (!imageName) return "";

  try {
    new URL(imageName);
    return imageName;
  } catch {
    return `${baseUrl}/apis/storage/assets/uploads/${imageName}`;
  }
};